import React from 'react';
import { components } from 'react-select';

export default (Option = (props) => {
  return <components.Option {...props} />;
});
